import styled from 'styled-components'

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  button {
    width: 80px;
    text-transform: uppercase;
  }
  .more-button {
    width: 40px !important;
  }
  .is-danger {
    color: #fff;
    background-color: #d9534f;
    border-color: #d43f3a;
    &:hover {
      color: #fff;
      background-color: #c9302c;
      border-color: #ac2925;
    }
  }
`
export const Wrapper = styled.div`
  display: flex;
  form {
    width: 100%;
  }
`

export const Container = styled(Wrapper)`
  width: 90%;
  margin: 2em;
`

export const FormFieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px;
  width: 100%;

  input,
  .ant-select,
  select {
    color: #0e76eb;
    width: 100%;
    border-radius: 4px;
    transition: all 0.2s ease;
    background-color: transparent;
    font-size: 14px;
    outline: none;
    resize: none;
    overflow: hidden;
    text-align: left;
    border: none;
    border-bottom: 1px solid rgba(176, 180, 186, 0.42);
    &[type='number'] {
      width: 40%;
    }
    &[type='radio'] {
      width: auto;
    }
    &[type='checkbox'] {
      cursor: pointer;
      width: auto;
      min-height: 14px;
      padding: 0;
      border: 2px solid #0e76eb;
      transition: all 0.2s ease;
    }
    &:disabled {
      cursor: not-allowed;
      color: rgba(0, 0, 0, 0.65);
      border-bottom: none !important;
    }
  }
  .ant-select-selector {
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    color: rgba(0, 0, 0, 0.65) !important;
  }
  .ant-select-selection-item {
    color: #0e76eb;
  }
  .ant-select-arrow {
    right: 0 !important;
  }
  .ant-select-multiple.ant-select-allow-clear .ant-select-selector {
    width: 100% !important;
  }
`

export const FormFieldGroup = styled.div`
  display: flex;
  flex-basis: 70%;
  align-items: center;
  > a {
    font-weight: 600 !important;
  }
  input,
  select,
  textarea {
    margin-left: 8px;
    &:first-child {
      margin-left: 0;
    }
  }
  .ant-select {
    &:disabled {
      border-bottom: none !important;
    }
  }
`

export const FormFieldLabel = styled.label`
  width: 40%;
  font-weight: bold;
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
`

export const FormErrorMessage = styled.div`
  width: 100%;
  display: flex;
  color: #f00;
  justify-content: flex-end;
`
